import React from 'react';
import { CheckCircle } from 'lucide-react';
export function ThankYou() {
  return <section className="w-full min-h-[calc(100vh-57px)] px-6 md:px-12 py-24 bg-navy flex items-center justify-center" data-id="element-177">
      <div className="max-w-2xl mx-auto text-center" data-id="element-178">
        <div className="mb-8 flex justify-center" data-id="element-179">
          <div className="w-20 h-20 bg-primary/20 rounded-full flex items-center justify-center" data-id="element-180">
            <CheckCircle size={48} className="text-primary" data-id="element-181" />
          </div>
        </div>
        <h1 className="font-display text-4xl md:text-5xl font-bold mb-6" data-id="element-182">
          Thank You For Your Booking!
        </h1>
        <p className="text-lg md:text-xl text-gray-300 mb-8" data-id="element-183">
          Please check your email for more info about your booking. If you don't
          see an email, check your spam folder in case it landed there.
        </p>
        <div className="w-full aspect-video max-w-2xl mx-auto" data-id="element-184">
          <iframe width="100%" height="100%" src="https://www.youtube.com/embed/Y51qFYOfcns?si=ZoJmwliEEYt4XnZJ" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen className="rounded-lg" data-id="element-185" />
        </div>
      </div>
    </section>;
}